import {HeadCell} from "interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "client",
    disablePadding: false,
    label: "Cliente",
  },
  {
    id: "dni",
    disablePadding: false,
    label: "Cédula",
  },
  {
    id: "amount",
    disablePadding: false,
    label: "Monto",
  },
  {
    id: "reference",
    disablePadding: false,
    label: "Referencia",
  },
  {
    id: "status",
    disablePadding: false,
    label: "Estatus",
  },
];
